import { PAYMENT_CARD_BINDING_AMOUNT } from '@common/const/billing/payment';
import React from 'react';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Price } from 'src/shared/ui/price';

export const CardBindingText = (props: BoxProps) => (
  <Box component="span" {...props}>
    Сейчас спишем <Price value={PAYMENT_CARD_BINDING_AMOUNT} /> и сразу вернем.&thinsp;
  </Box>
);
